import React from 'react';
import PropTypes from 'prop-types';
import PopUp from '@/components/Modal/PopUp';
import './style';

class RiseError extends React.PureComponent {
  static propTypes = {
    hide: PropTypes.func,
    txt: PropTypes.string,
    btnTxt: PropTypes.string,
  };

  static defaultProps = {
    btnTxt: 'OK',
  };

  handleHideModal = (e) => {
    e.preventDefault();
    this.props.hide();
  };

  render() {
    return (
      <PopUp>
        <div className="record-error">
          {/* <div className="record-error-close" onClick={this.handleHideModal} /> */}
          <div className="record-error-bg"><div className="record-error-professor" /></div>
          <div className="record-error-content">{this.props.txt}</div>
          <div className="record-error-btn" onClick={this.handleHideModal}>{this.props.btnTxt}</div>
        </div>
      </PopUp>
    );
  }
}

export default RiseError;
